import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        classifiers: '=',
        sites: '=',
        company: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>{{ 'survey.Survey group' | translate }}</h1>
        <ul class="actions01">
            <li>
                <a class="btn edit"
                    ng-if="(!vm.surveyGroup.deadline || !vm.MomentService.isPassedTimeStamp(vm.surveyGroup.deadline)) && !vm.isCourseSurvey"
                    ng-click="vm.editSurveyGroup()"
                >{{ 'survey.Edit general data' | translate }}</a>
                <a ui-sref="authorized.courses.courses.edit.occurrence.edit.schedule({id: vm.surveyGroup.courseId, occurrenceId: vm.surveyGroup.occurrenceId })"
                    class="btn edit"
                    ng-if="(!vm.surveyGroup.deadline || !vm.MomentService.isPassedTimeStamp(vm.surveyGroup.deadline)) && vm.isCourseSurvey"
                >{{ 'survey.Edit general data' | translate }}</a>
            </li>
            <li>
                <a ng-if="!vm.isCourseSurvey"
                   class="btn edit"
                   ng-click="vm.editTranslations()"
                >{{ 'survey.Edit translations' | translate }}</a>
            </li>
        </ul>
    </div>
    <div class="form">
        <div class="row">
            <label class="label">{{ 'survey.Group name' | translate }}</label>
            <div class="items">
                <span class="text">{{ vm.surveyGroup.activeI18n.name }}</span>
            </div>
        </div>
        <div class="row">
            <label class="label">{{ 'survey.Deadline' | translate }}</label>
            <div class="items">
                <span class="text">{{ vm.MomentService.formatTimeStamp(vm.surveyGroup.deadline) }}</span>
            </div>
        </div>
        <div class="row">
            <label class="label">{{ 'survey.Associated form' | translate }}</label>
            <div class="items">
                <span class="text">{{ vm.surveyGroup.formActiveI18n.name }}</span>
            </div>
        </div>
        <div class="row">
            <label class="label">
                {{ 'survey.Introduction text' | translate }}
                <small>{{ 'survey.introduction_text_refinement' | translate }}</small>
            </label>
            <div class="items">
                <span class="text" ng-bind-html="vm.getIntroduction()"></span>
            </div>
        </div>
    </div>
    <survey-detail-participants
        survey-group="vm.surveyGroup"
        bulk-ids="vm.bulkIds"
        is-group-deadline-passed="vm.isGroupDeadlinePassed"
        classifiers="vm.classifiers"
        sites="vm.sites"
        reload="vm.reload()"
    />
    <div class="form ng-scope" ng-if="vm.surveyGroup.sortedByNameParticipants.length">
        <div class="row inline" ng-if="!vm.isGroupDeadlinePassed && !vm.isCourseSurvey">
            <label class="label">{{ 'general.Bulk actions' | translate }}</label>
            <div class="items">
                <select class="form-control small" ng-model="vm.action">
                    <option value="send-notifications">{{ 'survey.Send notifications' | translate }}</option>
                </select>
                <button class="btn bordered02" ng-click="vm.handleBulkAction()">{{ 'general.Ok' | translate }}</button>
            </div>
        </div>
        <!--<p class="desc">Reports sent by Firstname Lastname</p>-->
        <ul class="actions01">
            <!--<li><a ui-sref="reviews.survey.calendar()" class="btn main">Save</a></li>-->
            <!--<li><a ui-sref="reviews.interviews.calendar()" class="btn bordered02">Save</a></li>-->
            <li class="primary">
                <a ng-click="vm.viewReport()" ng-if="vm.PrivilegeService.canViewSurveyReports()" href="" target="_blank" class="btn bordered02">
                    {{ 'survey.View summary report' | translate }}
                </a>
            </li>
            <li ng-if="vm.PrivilegeService.canExportSurveyResults()" class="primary">
                <a ng-click="vm.exportCsv()" class="btn bordered02">{{ 'survey.Export results as CSV' | translate }}</a>
            </li>
            <!--<li><a class="btn bordered02">Send reports</a></li>-->
            <!--<li><a ui-sref="reviews.interviews.calendar()" class="btn discrete" >Cancel</a></li>-->
        </ul>
    </div>
    `
})
export default class {
    constructor ($window, $state, $translate, lodash, toastr,
                 MomentService, ModalService, PrivilegeService, TokenService, SurveyGroupService,
                 AuthResource, SurveyGroupResource,
                 SURVEY_PARTICIPANT_STATUS_ENUM, SURVEY_INTRODUCTION_PLACEHOLDER_ENUM) {
        this.$window = $window;
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.SurveyGroupService = SurveyGroupService;
        this.SurveyGroupResource = SurveyGroupResource;
        this.AuthResource = AuthResource;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
        this.SURVEY_INTRODUCTION_PLACEHOLDER_ENUM = SURVEY_INTRODUCTION_PLACEHOLDER_ENUM;
    }

    $onInit () {
        this.bulkIds = [];
        this.action = 'send-notifications';
        this.isGroupDeadlinePassed = this.surveyGroup.deadline && this.MomentService.isPassedTimeStamp(this.surveyGroup.deadline);
        this.isCourseSurvey = this.SurveyGroupService.isCourseSurveyType(this.surveyGroup);
    }

    getIntroduction () {
        const surveyGroupI18n = this.surveyGroup.activeI18n;
        const deadlinePlaceholder = this.SURVEY_INTRODUCTION_PLACEHOLDER_ENUM.GROUP_DEADLINE;
        const deadline = this.MomentService.formatTimeStamp(this.surveyGroup.deadline);
        return this.lodash.replace(surveyGroupI18n.introduction, new RegExp(deadlinePlaceholder, 'g'), deadline);
    }

    editSurveyGroup () {
        const { surveyGroup, company } = this;
        this.ModalService.open({
            template: '<modals-survey-edit uib-modal-instance="vm.$uibModalInstance" survey-group="vm.surveyGroup" company="vm.company"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.surveyGroup = surveyGroup;
                this.company = company;
            }
        }).then((updatedSurveyGroup) => {
            this.surveyGroup = updatedSurveyGroup;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
        });
    }

    editTranslations () {
        const { surveyGroup, company } = this;
        this.ModalService.open({
            size: 'xlarge',
            template: '<modals-survey-translation uib-modal-instance="vm.$uibModalInstance" survey-group="vm.surveyGroup" company="vm.company"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.surveyGroup = surveyGroup;
                this.company = company;
            }
        }).then((updatedSurveyGroup) => {
            this.surveyGroup = updatedSurveyGroup;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
        });
    }

    handleBulkAction () {
        if (!this.bulkIds.length) {
            return;
        }
        if (this.action === 'send-notifications') {
            const missingEmailUsers = this.getMissingEmailUsers();

            if (missingEmailUsers) {
                this.toastr.error(
                    this.$translate.instant(
                        'survey.Can not send notification to users without e-mail: {users}',
                        { users: missingEmailUsers }
                    )
                );
            }
            else {
                this.sendNotifications();
            }
        }
    }

    getMissingEmailUsers () {
        const missingEmailUsers = [];
        this.surveyGroup.sortedByNameParticipants.forEach((item) => {
            if (this.lodash.includes(this.bulkIds, item.id)) {
                if (!this.surveyGroup.users[item.userId].primaryEmail) {
                    missingEmailUsers.push(this.surveyGroup.users[item.userId].displayName);
                }
            }
        });
        return missingEmailUsers.join(', ');
    }

    sendNotifications () {
        this.ModalService.confirm(this.getNotificationConfirmMessage(), 'medium').then(() => {
            this.SurveyGroupResource.notify({ id: this.surveyGroup.id }, { ids: this.bulkIds }).$promise.
                then(() => {
                    this.reload().then((surveyGroup) => {
                        this.surveyGroup = surveyGroup;
                        this.toastr.success(this.$translate.instant('survey.Notifications sent'));
                        this.bulkIds = [];
                    });
                })
                .catch((response) => {
                    this.toastr.error(response.data[0].message);
                });
        });
    }

    getNotificationConfirmMessage () {
        const notFinishedEnums = [
            this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_COMPLETED,
            this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_STARTED
        ];
        const sentParticipants = this.surveyGroup.sortedByNameParticipants.filter((item) => {
            return this.lodash.includes(this.bulkIds, item.id)
                && notFinishedEnums.includes(item.status);
        });
        let users = '';
        if (sentParticipants.length) {
            users = sentParticipants.map((item) => this.surveyGroup.users[item.userId].displayName).join(', ');
            return this.$translate.instant(
                'survey.Please confirm sending notifications to already sent users {users}', { users }
            );
        }
        const participants = this.surveyGroup.sortedByNameParticipants.filter((item) => {
            return this.lodash.includes(this.bulkIds, item.id);
        });
        users = participants.map((item) => this.surveyGroup.users[item.userId].displayName).join(', ');
        return this.$translate.instant(
            'survey.Please confirm sending notifications to {users}', { users }
        );
    }

    reload () {
        return this.SurveyGroupResource.get({
            id: this.surveyGroup.id,
            expand: 'formActiveI18n,sortedByNameParticipants,users,activeI18n,surveyGroupI18ns'
        }).$promise;
    }

    viewReport () {
        const href = this.$state.href('survey.report', { guid: this.surveyGroup.guid });
        if (!this.MomentService.isPassedTimeStamp(this.surveyGroup.deadline)) {
            this.ModalService.confirm(
                this.$translate.instant('survey.Survey deadline has not yet passed and the displayed report may contain data that is not yet complete. Are you sure you wish to continue?'),
                'medium')
                .then(() => {
                    this.$window.open(href, '_blank');
                });
        }
        else {
            this.$window.open(href, '_blank');
        }
    }

    exportCsv () {
        if (!this.MomentService.isPassedTimeStamp(this.surveyGroup.deadline)) {
            this.ModalService.confirm(
                this.$translate.instant('survey.Survey deadline has not yet passed and the downloaded report may contain data that is not yet complete. Are you sure you wish to continue?'),
                'medium')
                .then(() => {
                    this.initCsvExport();
                });
        }
        else {
            this.initCsvExport();
        }
    }

    initCsvExport () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}survey/survey-group/export-results/${this.surveyGroup.id}?tacToken=${token}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/detail/index.js